
import classNames from 'classnames'

import styles from './link.module.sass'

function Link(props) {
	const {
		href,
		url,
		alt,
		target,
		title,
		className,
		children,
		ID,
		fields,
		object_id,
		post_parent,
		active,
		active_parent,
		...rest
	} = props

	const displayedProps = {
		href: href || url,
		alt,
		target,
		title,
	}

	return (
		<a
			{...displayedProps}
			{...rest}
			className={classNames(styles.link, className)}
		>
			{children}
		</a>
	)
}

export default Link